/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'account-arrow-left-outline': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M17 18h4v-2h-4v-2l-3 3 3 3v-2M11 4C8.8 4 7 5.8 7 8s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4m0 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 7c-2.7 0-8 1.3-8 4v3h9.5c-.3-.6-.4-1.2-.5-1.9H4.9V17c0-.6 3.1-2.1 6.1-2.1.5 0 1 .1 1.5.1.3-.6.6-1.2 1.1-1.7-1-.2-1.9-.3-2.6-.3"/>'
  }
})
